export default [
    {
        id: "nav.top.home",
        path: "/",
        text: "home",
        class: "",
    },
    {
        id: "nav.top.deals",
        path: "/deals",
        text: "deals by location",
        class: "full-text",
    },
    {
        id: "nav.top.deals-short",
        path: "/deals",
        text: "locations",
        class: "short-text",
    },
    {
        id: "nav.top.faqs",
        path: "/faqs",
        text: "faqs",
        class: "full-text",
    },
    {
        id: "nav.top.faqs-short",
        path: "/faqs",
        class: "short-text"
    },
    {
        id: "nav.top.contact",
        path: "/contact",
        text: "contact us",
        class: "full-text",
    },
    {
        id: "nav.top.contact-short",
        path: "/contact",
        text: "contact",
        class: "short-text",
    },
]